import { graphql } from "@/data-access/graphql";

export const SavedViewFragment = graphql(`
  fragment SavedViewFragment on FeedSavedViewType @_unmask {
    feedArticleFilter(asFlat: true)
    feedId
    id
    isUserStarred
    name
    # Deprecated field
    urlSelectedFilters
  }
`);
